import {createSelector} from "reselect";
import createPathByFilters from "../utils/createPathByFilters";

export const breadcrumbsSelector = (state) => state.seo.breadcrumbs;
export const seoTypeSelector = (state, type) => state.seo[type];
export const advantagesSelector = (state) => state.seo.advantages;
export const faqSelector = (state) => state.seo.faq;
export const pathSelector = (state) => state.path;
export const tagsMapSelector = (state) => state.tags
export const filtersSelector = (state, isCustomStore) => {
  const {filters} = state;
  const {rootPath, department, category, type} = filters;

  const combineList = isCustomStore
    ? [department, category, type]
    : [rootPath, department, category, type];

  let {combine} = filters;
  combine =
    combine ||
    combineList.reduce((acc, i) => {
      if (i) {
        return `${acc}/${i}`;
      }
      return acc;
    });

  return {
    rootPath,
    combine,
    cod: filters.ownDesignPath,
    tag: filters.tag,
    subTag: filters.subTag,
    page: filters.page,
    search: filters.search,
    sort: filters.sort,
    price: filters.price,
    loading: filters.loading,
    loaded: filters.loaded
  };
};
export const rootPathSelector = (state) => state.filters.rootPath;
export const sortSelector = (state) => state.sort;
export const productsMapSelector = (state) => state.products;
export const buyInOneClickSelector = (state) => state.buyInOneClick;
export const paginationSelector = (state) => state.pagination;
export const isMobileSelector = (state) => state.isMobile;
export const authenticityTokenSelector = (state) => state.authenticityToken;

export const tagsSelector = createSelector(
  tagsMapSelector,
  filtersSelector,
  (tags, filters) => {
    return tags.map((tag) => {
      return {
        ...tag,
        path: createPathByFilters(filters, {
          tag: tag.parametrazedName,
          subTag: ``,
          page: 1
        }),
        children: tag.children.map((subTag) => {
          return {
            ...subTag,
            path: createPathByFilters(filters, {
              tag: tag.parametrazedName,
              subTag: subTag.parametrazedName,
              page: 1
            }),
            active: subTag.parametrazedName === filters.subTag
          };
        }),
        active: tag.parametrazedName === filters.tag
      };
    });
  }
);
export const tagsSidebarSelector = createSelector(tagsSelector, (tags) => {
  const featured = [];
  const normal = [];
  const hidden = [];

  tags.forEach((tag) => {
    if (tag.position < 10) {
      featured.push(tag);
    } else if (tag.position < 100) {
      normal.push(tag);
    } else if (tag.position > 99) {
      hidden.push(tag);
    }
  });

  return {
    featured,
    normal,
    hidden
  };
});
export const tagCloudSelector = createSelector(tagsSelector, (tags) => {
  return tags.reduce((acc, tag) => {
    if (tag.active) {
      return [...tag.children];
    }
    return [...acc];
  }, []);
});
export const productsSelector = createSelector(
  productsMapSelector,
  (products) => products
);
